
const state = {
  carBasicInfo: {},
  reportId: 0,
  note: '' // 评估简述
}

const mutations = {
  'UPDATE_CAR_BASIC_INFO'(state, basicInfo) {
    state.carBasicInfo = basicInfo
  },
  'UPDATE_CAR_REPORT_ID'(state, id) {
    state.reportId = id
  },
  'UPDATE_CAR_REMARK_INFO'(state, note) {
    state.note = note
  }
}

const actions = {
  UPDATE_CAR_BASIC_INFO({ commit }, basicInfo) {
    commit('UPDATE_CAR_BASIC_INFO', basicInfo)
  },
  UPDATE_CAR_REMARK_INFO({ commit }, note) {
    commit('UPDATE_CAR_REMARK_INFO', note)
  }
}
export default {
  state,
  actions,
  mutations
}
